import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class RouteInfoService {
  
  private routeInfoBehaviorSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  routeInfo = this.routeInfoBehaviorSubject.asObservable();

  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.routeInfoBehaviorSubject.next(event.url);
    });
  }
  
}
